import React from 'react';
import classNames from 'classnames';

interface IProps {
  src: string;
  alt?: string;
  title?: string;
  onLoad?: (event: React.SyntheticEvent<HTMLImageElement, Event>) => void;

  // aspect = width / height, e.g. a 800x600 image would be 1.33
  aspect?: number;

  // make image full width of container even if it's smaller than the container
  // set to 'none' to bypass the container entirely (may cause a repaint on load)
  imageBox?: 'default' | 'fullWidth' | 'none';
}

function getPaddingStyle(aspect) {
  if (!aspect) return;

  return {
    style: {
      paddingBottom: `${Math.floor(100 / aspect)}%`,
    },
  };
}

export default function LazyImage({
  src,
  alt,
  title,
  onLoad,
  aspect = 1,
  imageBox = 'default',
}: IProps) {
  if (imageBox === 'none') {
    return (
      <img
        src={src}
        alt={alt}
        title={title}
        loading="lazy"
        onLoad={onLoad}
      />
    );
  }

  const classes = classNames(
    'image-box',
    { 'image-box--full-width': imageBox === 'fullWidth' },
  );

  return (
    <div
      className={classes}
      {...getPaddingStyle(aspect)}
    >
      <img
        src={src}
        alt={alt}
        title={title}
        loading="lazy"
        onLoad={onLoad}
      />
    </div>
  );
}
